import axios from "./axios";

export const getPress = () => axios.get().get(`/press`)
